import React, { useState, useEffect, useRef } from 'react';
import { StackedCarousel, ResponsiveContainer } from 'react-stacked-center-carousel';
import { SCREEN_SIZES } from 'style';
import useWindowSize from 'hooks/useWindowSize';
import CardsMobile from './components/CardsMobile';
import { CARDS } from './consts';

import {
  PeopleBackground,
  PeopleContainer,
  PeopleHeader,
  StyledCarousel,
  Title,
  Link,
  Card,
  CardsMobileWrapper
} from './styled';

const People = () => {
  const ref = useRef(StackedCarousel);
  const { width: windowWidth } = useWindowSize();
  const [cardWidth, setCardWidth] = useState(0);
  const isMobile = windowWidth <= SCREEN_SIZES.tabletLandscape;

  useEffect(() => {
    if (windowWidth > 1200) {
      setCardWidth(760);
    } else {
      setCardWidth(500);
    }
  }, [windowWidth]);

  return (
    <PeopleBackground>
      <PeopleContainer>
        <PeopleHeader>
          <Title>People</Title>
          <Link href="https://safetywing.com/team" target="_blank">
            See everyone on our team page ↗
          </Link>
        </PeopleHeader>
        {!isMobile && (
          <ResponsiveContainer
            carouselRef={ref}
            render={(width, carouselRef) => {
              return (
                <StyledCarousel
                  ref={carouselRef}
                  slideComponent={Card}
                  slideWidth={cardWidth}
                  carouselWidth={width}
                  data={CARDS}
                  maxVisibleSlide={3}
                  disableSwipe
                  transitionTime={450}
                />
              );
            }}
          />
        )}

        <CardsMobileWrapper>
          {isMobile && <CardsMobile cards={CARDS} />}
        </CardsMobileWrapper>
      </PeopleContainer>
    </PeopleBackground>
  );
};

export default People;
